export const translations = {
  facebook: "Facebook",
  instagram: "Instagram",
  whatsApp: "WhatsApp",
  tiktok: "Tiktok",
};
